import React from 'react';

export function Stars({ rating, size = 'text-sm' }) {
  return (
    <span className={`inline-flex items-center gap-0.5 ${size} leading-none`} aria-label={`Rated ${rating} out of 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <span key={i} className={i <= Math.round(rating) ? 'text-amber2' : 'text-silver'}>
          ★
        </span>
      ))}
    </span>
  );
}

export function StockBadge({ stock }) {
  const cfg =
    stock > 10
      ? { c: 'text-ok bg-ok/10', t: 'In Stock' }
      : stock > 0
      ? { c: 'text-warn bg-warn/10', t: `Only ${stock} left` }
      : { c: 'text-bad bg-bad/10', t: 'Out of Stock' };
  return (
    <span data-testid="stock-badge" className={`inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest px-2.5 py-1 rounded-full ${cfg.c}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {cfg.t}
    </span>
  );
}
